import React, { useCallback, useEffect } from 'react';
import { Survey, useSurvey } from './Survey';

type SurveyProps = React.ComponentProps<typeof Survey>;

const oneDay = 86400000;

export const DailySurvey: React.FC<SurveyProps> = ({ onComplete, ...rest }) => {
  const { token } = useSurvey(rest.ratePlan);
  const surveyLastTakenKey = `last-survey-taken-${token}`;
  const lastSurveyTaken = window.localStorage.getItem(surveyLastTakenKey);
  const skipSurvey = !!lastSurveyTaken && parseInt(lastSurveyTaken) > Date.now() - oneDay;

  const patchedOnComplete = useCallback(() => {
    window.localStorage.setItem(surveyLastTakenKey, Date.now().toString());
    onComplete?.();
  }, [surveyLastTakenKey, onComplete]);

  useEffect(() => void (skipSurvey && onComplete?.()), [skipSurvey, onComplete]);

  return skipSurvey ? null : <Survey {...rest} onComplete={patchedOnComplete} />;
};
